// extracted by mini-css-extract-plugin
export default {"root":"ImageCropModal_root__dRTac","cropped":"ImageCropModal_cropped__+TT9I","canvas":"ImageCropModal_canvas__3Bgwy"};